import axios from 'axios';
import i18n from '../i18n';

const FALLBACK_URL = 'https://backend-production-a587.up.railway.app';

function resolveBaseUrl() {
  const raw = process.env.REACT_APP_API_URL || '';
  // Railway voi asettaa muuttujan arvoksi "=https://..." (etuliitteellä =)
  // jolloin Axios käyttäisi sitä suhteellisena polkuna. Poistetaan = alussa.
  const clean = raw.startsWith('=') ? raw.slice(1) : raw;
  const url = clean.startsWith('http') ? clean : FALLBACK_URL;
  return url;
}

const api = axios.create({
  baseURL: resolveBaseUrl(),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('safepro_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Kielitieto backendin omille virheilmoituksille (Epic 6.3, 23.9.2026) —
  // kirjautuneelle käyttäjälle backend käyttää ensisijaisesti tietokannan
  // users.language-arvoa, mutta kirjautumattomille pyynnöille (login,
  // salasanan palautus) tämä otsikko on ainoa lähde. Käytetään kieltä, jota
  // käyttöliittymä näyttää (#70): ensikertalaisella ei ole vielä tallennettua
  // valintaa, mutta i18n on valinnut kielen selaimen asetuksesta.
  const lang = i18n.language || localStorage.getItem('safepro_language');
  if (lang) {
    config.headers['X-Lang'] = lang;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Kirjautumisyrityksen oma 401 (väärä sähköposti/salasana) ei tarkoita
    // vanhentunutta sessiota — ei pakoteta uudelleenohjausta, jotta LoginPage
    // ehtii näyttää virheilmoituksen eikä sivu lataudu tyhjäksi kesken sitä.
    const isLoginRequest = err.config?.url?.includes('/api/auth/login');
    if (err.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('safepro_token');
      localStorage.removeItem('safepro_user');
      // Paluuosoite talteen (esim. sähköpostin linkki hälytykseen vanhentuneella istunnolla, #32)
      const path = window.location.pathname + window.location.search;
      if (!path.startsWith('/kirjaudu') && path !== '/' && path !== '/dashboard') {
        try { sessionStorage.setItem('safedigi_return_to', path); } catch { /* ei sessionStoragea */ }
      }
      window.location.href = '/kirjaudu';
    }
    return Promise.reject(err);
  }
);

export const isStaging = resolveBaseUrl().includes('staging');

export default api;
